<div class="__menu-header u-flex-row u-flex-justify-content-space-between u-flex-align-items-center">
    <ng-container *ngIf="!!label">
        <label [innerHtml]="label"></label>
    </ng-container>
    <ng-container [ngTemplateOutlet]="actionTemplate"></ng-container>
</div>
<div class="__menu-group" [ngClass]="classList">
    <ng-content></ng-content>
</div>
